import { component } from "picoapp";
import { formatMoney } from "../lib/currency";

export default component((node) => {
  window.addEventListener("price:update", ({ detail }) => {
    const { comparePrice, price, key } = detail;

    if (node.dataset.key && node.dataset.key !== key) {
      return;
    }

    if (price) {
      node.innerHTML = formatMoney(
        price,
        // eslint-disable-next-line no-template-curly-in-string
        "${{ amount_no_trailing_zeroes }}",
        false
      );
      if (comparePrice) {
        node.classList.add("has-compare-price");
      } else {
        node.classList.remove("has-compare-price");
      }
    } else {
      node.innerHTML = null;
    }
  });
});
